import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import loc from '../data/Location.json'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'

type Category__type = {
  _id: string
  Name: string
}

export function AddWebsiteCategories() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [categories, setCategories] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])

  console.log('selectedCategories', selectedCategories)
  console.log("Error", error)
  const [searchedCategories, setSearchedCategories] = useState([])

  // const formik = useFormik({
  //   initialValues: initialValues,
  //   validationSchema: registrationSchema,
  //   enableReinitialize: true,
  //   onSubmit: (values, {setStatus, setSubmitting}) => {
  //     console.log("idhar");

  //     setLoading(true)
  //     setTimeout(() => {
  //       try {
  //         // let request: any = values;
  //         // request.agencyAssociated = agencyAssociated;
  //         setLoading(false)
  //         setSubmitting(false)
  //         history.push({
  //           pathname: '/agencyDetails',
  //           state: {
  //             ...history.location.state,
  //             ...{companyDetails: values},
  //           },
  //         })
  //       } catch {
  //         setLoading(false)
  //         setSubmitting(false)
  //         setStatus('Registration process has broken')
  //         // Remove logs when not needed
  //       }
  //     }, 1000)
  //   },
  // })

  // const checkHandle = (cat) => {
  //   let x = selectedCategories?.findIndex((c) => c._id === cat._id)
  //   if (x == -1) {
  //     // setSelectedCategories((previousCategories) => [
  //     //   ...previousCategories,
  //     //   {_id: cat._id, Name: cat.Name},
  //     // ])
  //     selectedCategories.push({ _id: cat._id, Name: cat.Name, AssociatedPhrases: cat.AssociatedPhrases })
  //     setSelectedCategories(selectedCategories)
  //     setError(false)
  //   } else {
  //     selectedCategories.splice(x, 1)
  //     setSelectedCategories([...selectedCategories])
  //   }
  //   setCategories([...categories])
  //   if (selectedCategories.length === 0) {
  //     setError(true)
  //   }
  // }

  const checkHandle = (cat) => {
    const selectedIndex = selectedCategories.findIndex((c) => c._id === cat._id);
    let updatedSelectedCategories = [...selectedCategories];

    if (selectedIndex === -1) {
      updatedSelectedCategories.push({ _id: cat._id, Name: cat.Name, AssociatedPhrases: cat?.AssociatedPhrases });
    } else {
      updatedSelectedCategories.splice(selectedIndex, 1);
    }

    setSelectedCategories(updatedSelectedCategories);
    setError(updatedSelectedCategories.length === 0);
    setCategories([...categories]); // This line may not be necessary depending on your use case
  };

  const handleCategorySelectAll = () => {
    const allCategoriesSelected = selectedCategories.length === categories.length;
    if (allCategoriesSelected) {
      setSelectedCategories([]);
      setError(true);
    } else {
      setSelectedCategories([...categories]);
      setError(false);
    }
  };





  const search = (e) => {
    setSearchValue(e.target.value)
  }

  useEffect(() => {
    setSelectedCategories(
      history.location.state?.edit ? history.location.state.website.Categorys : []
    )
  }, [])

  const deleteCategory = (x, ind) => {
    // const category__to__remove = x._id
    // const filtered_Category = selectedCategories.filter((item) => item._id !== category__to__remove)
    // setSelectedCategories(filtered_Category)
    // console.log(selectedCategories)
    // if (selectedCategories.length < 1) {
    //   setError(true)
    //   setSelectedCategories([{_id: 'startvalue', Name: ''}])
    // }
  }

  // useEffect(()=>{
  //   let x= []
  //   for(let i=0;i<categories.length;i++){
  //     if(categories[i].checked){
  //       x.push(categories[i])
  //     }
  //   }
  //   setSelectedCategories(x)
  // },[categories])

  useEffect(() => {
    httpService.getData(
      '/category-master?search=' + searchValue,
      (res) => {
        console.log(res.data.data.data)
        setCategories(res.data.data.data)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )
  }, [searchValue])

  // const submitForm = (e) => {
  //   e.preventDefault()
  //   if (selectedCategories.length === 0) {
  //     setError(true)
  //   } else {
  //     setError(false)
  //     setLoading(true)
  //     // setSelectedCategories(selectedCategories.splice(0, 1))
  //     console.log(selectedCategories)
  //     httpService.patchData(
  //       '/website/update/?step=3',
  //       {
  //         id: history.location.state.id,
  //         Categorys: selectedCategories,
  //       },
  //       (res) => {
  //         setLoading(false)
  //         history.push({
  //           pathname: '/addWebsite/tags',
  //           state: {
  //             ...history.location.state,
  //             selectedCategories,
  //           },
  //         })
  //       },
  //       (err) => {
  //         setLoading(false)

  //         console.log(err)
  //       }
  //     )
  //   }
  // }



  const submitForm = (e) => {
    e.preventDefault();
    if (selectedCategories.length === 0) {
      setError(true);
    } else {
      setError(false);
      setLoading(true);

      const formattedCategories = selectedCategories.map((category) => ({
        _id: category._id,
        Name: category.Name,
        AssociatedPhrases: category.AssociatedPhrases, // Include AssociatedPhrases
      }));

      httpService.patchData(
        '/website/update/?step=3',
        {
          id: history.location.state.id,
          Categorys: formattedCategories,
        },
        (res) => {
          setLoading(false);
          history.push({
            pathname: '/addWebsite/tags',
            state: {
              ...history.location.state,
              selectedCategories,
            },
          });
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      );
    }
  };




  const check = (cat) => {
    let x = selectedCategories?.findIndex((c) => c._id === cat._id)
    console.log(x)
    // selectedCategories?.findIndex((c) => c._id === cat._id)
    return x > -1
  }

  const [nameError, setNameError] = useState(false)
  // const validateName = (name: any) => {
  //   httpService.getData(
  //     '/' + history.location.state?.type.toLowerCase() + '-master/',
  //     (res: any) => {
  //       if (history.location.state?.type == 'Agency') {
  //         htmlFor (var i = 0; i < res.data.data?.agencies.length; i++) {
  //           if (res.data.data?.agencies[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       } else {
  //         htmlFor (var i = 0; i < res.data.data?.brands.length; i++) {
  //           if (res.data.data?.brands[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       }
  //     },
  //     (err: any) => {}
  //   )
  // }

  // useEffect(() => {
  //   setSelectedCategories([{_id: 'startvalue', Name: ''}])
  // }, [])

  return (
    <div className='CompanyDetailsOuter '>
      <AddWebsiteLeftBreadcrum currentStep='3' />
      <form
        className='CompanyDetails'
        noValidate
        id='kt_login_signup_form'
        onSubmit={submitForm}
        style={{ marginBottom: '100px' }}
      >
        <h2 className=''>Website Categories</h2>
        {error && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span className='text-danger' role='alert'>
                Select atleast 1 category.
              </span>
            </div>
          </div>
        )}
        <div className='row pt-4 pe-5 '>
          <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
            {selectedCategories &&
              selectedCategories?.map((x, ind) => {
                return (
                  <div
                    className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'
                    id={x._id}
                  >
                    {x.Name}
                    <img
                      style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                      onClick={() => checkHandle(x)}
                      src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                      alt='cross'
                    />
                  </div>
                )
              })}
          </div>
        </div>
        <div className='row pt-4 pe-5 '>
          <div className='col'>
            <Input
              type='text'
              placeholder='Search Categories.'
              className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
              onChange={search}
              value={searchValue}
              prefix={
                <>
                  <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                </>
              }
            />
            {/* <div className="input-group mb-5">
              <span className="input-group-text" style={{border:"none", paddingRight:"5px"}} id="basic-addon1">
                  <span className="svg-icon svg-icon-3x">
                      <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt="search" />
                  </span>
              </span>
              <input type="text" className="form-control form-control-solid rounded-4 bg-white-100" style={{paddingLeft:"2px"}} onChange={search} value={searchValue} placeholder="Search categories"/>
          </div> */}
          </div>
        </div>
        <div className='d-flex align-items-center jEnd  px-3 py-2 m-2 '>
          <div className='custom-btn' onClick={handleCategorySelectAll}>  {selectedCategories.length === categories.length ? 'Cancel All' : 'Select All'}</div>
        </div>
        <div className='row pe-5 pb-5 '>
          <div className='col scrollContainer'>
            {categories?.map((cat, ind) => {
              return (
                <div className='form-check form-check-custom form-check-solid form-check-sm m-4'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    value={cat._id}
                    id={cat._id}
                    checked={selectedCategories?.findIndex((c) => c._id === cat._id) > -1}
                    onClick={() => checkHandle(cat)}
                  />
                  <label className='form-check-label' htmlFor={cat.Name}>
                    {cat.Name}
                  </label>
                </div>
              )
            })}
          </div>
        </div>

        <div className='d-flex pt-4 pe-5'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={() => {
              console.log('kidhar')
              // history.push({
              //   pathname: '/addWebsite/tags',
              //   state: {
              //     ...history.location.state,
              //   },
              // })
            }}
            disabled={loading || error}
          // disabled={
          //   formik.isSubmitting ||
          //   !formik.isValid ||
          //   nameError ||
          //   !checkGST(formik.values.gstNumber)
          // }
          >
            {!loading && <span className='indicator-label'>Next</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
            {/* <span className='indicator-label'>Next</span> */}
          </button>
          <Link
            to={{
              pathname: '/addWebsite/type',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
              Back
            </button>
          </Link>
        </div>
      </form>
    </div>
  )
}
